//export const API_URL_DEV = 'https://dsz_api.test/';
export const API_URL_DEV = 'https://api2.deutsches-schilddruesenzentrum.de/api/';
// export const API_URL_DEV = 'https://api.ddev.site/';
export const API_URL_PRODUCTION = 'https://api2.deutsches-schilddruesenzentrum.de/api/';
// export const API_URL_PRODUCTION = 'https://api.ddev.site/';

export const WEB_URL = 'https://www.deutsches-schilddruesenzentrum.de/'

// NAGY - Production key (for build)
const GOOGLE_MAPS_KEY_PRODUCTION = 'AIzaSyAG42okoESIXMuTUQj1532yxL3yWMitXTw'
// Development key (for yarn start)
const GOOGLE_MAPS_KEY_DEVELOPMENT = 'AIzaSyBh88Lizfs9zdaNOBZOskPevwJNtqnMY7E'

// Use different key based on environment
export const GOOGLE_MAPS_KEY = process.env.NODE_ENV === 'production'
    ? GOOGLE_MAPS_KEY_PRODUCTION
    : GOOGLE_MAPS_KEY_DEVELOPMENT

export const MODE_DESKTOP = 'DESKTOP';
export const MODE_MOBILE = 'MOBILE';

export const SCHEMA_MAP = 'MAP';
export const SCHEMA_LIST = 'LIST';

export const DEFAULT_ZOOM = 6;
export const DEFAULT_ZOOM_MOBILE = 5.5;
